/*
 * @Author: Tina Huang
 * @Date: 2024-09-13 12:23:57
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-09-13 13:14:12
 * @Description:
 */
import { Input } from 'antd'
import FormItem from 'antd/es/form/FormItem'
export default function LuckinForm() {
  return (
    <>
      <FormItem label="取餐编号" name="orderNumber">
        <Input placeholder="如：9877" />
      </FormItem>
      <FormItem label="订单平台" name="orderPlatfrom">
        <Input placeholder="如：微信小程序" />
      </FormItem>
      <FormItem label="订单模式" name="orderMode">
        <Input placeholder="如：外送 1/2" />
      </FormItem>
      <FormItem label="订单属性" name="orderType">
        <Input placeholder="如：大杯" />
      </FormItem>
      <FormItem label="下单时间" name="orderTime">
        <Input placeholder="如：08-28 12:11" />
      </FormItem>
      <FormItem label="订单商品" name="orderContent">
        <Input placeholder="如：生椰丝绒拿铁" />
      </FormItem>
      <FormItem label="客制做法" name="orderCus">
        <Input placeholder="如：去糖，正常冰" />
      </FormItem>
      <FormItem label="做法配方" name="orderStep">
        <Input.TextArea placeholder="如：*【Ls140、Lm1】" />
      </FormItem>
      <FormItem label="店铺电话" name="orderStore">
        <Input placeholder="如：这里是店名 199999999" />
      </FormItem>
    </>
  )
}
